import React from 'react'
import { Paragraph } from 'modules/workspace/components/CreateWorkspaceCommon'
import { HalfDivider } from '../../WorkspaceSubscribeSummary.styles'

import { formatPriceShort } from 'utils/money'

const SUMMARY_ENTRY_COPY = {
  numberEditors: 'x Editor',
  numberViewers: 'x Viewers',
  numberExtraSeats: 'x Unused Editor Seats',
}

interface SeatSummaryEntries {
  numberEditors: number
  numberViewers: number
  numberExtraSeats: number
}

const formatSummaryEntry = (pricePerSeat: number) => (entries: any[]) =>
  entries.map(([key, value]) => {
    const typedKey = key as keyof SeatSummaryEntries
    const price = formatPriceShort(pricePerSeat * value, {
      trimDecimalIfZero: false,
    })

    return (
      <HalfDivider key={key}>
        <Paragraph>
          {value} {SUMMARY_ENTRY_COPY[typedKey]}
        </Paragraph>
        <Paragraph>{key === 'numberViewers' ? 'Free' : price}</Paragraph>
      </HalfDivider>
    )
  })

interface SeatSummaryProps extends SeatSummaryEntries {
  pricePerSeat: number
}

const SeatSummary: React.FC<SeatSummaryProps> = ({
  pricePerSeat,
  ...counters
}) => <>{formatSummaryEntry(pricePerSeat)(Object.entries(counters))}</>

export default SeatSummary
